module.exports = __webpack_public_path__ + "img/controduce.ba83866b.jpg";